import React, { useEffect, useRef, useState } from "react";
import FormCreator from "../../components/Forms/FormCreator";
import MolGrid from "../../components/Grid/MolGrid";
import Buttons from "../../components/ui/button/Buttons";
import { XeroPaymentListConfig } from "./data/XeroPaymentUpdateListConfig";
import { xeroPaymentListFormData } from "./data/XeroPaymentUpdateListForm.data";

const dataSource = [
  {
    companyName: "ABC Ltd",
    includedCerts: "SGBP009,SGBP009/1",
    overseasCharge: "Yes",
    paymentTerm: "Monthly",
    invoiceNumber: "INV-001",
    invoiceLink: "https://example.com",
    totalAmount: " $ 1000.00",
    status: "Pending",
    date: "4 Oct 2025 ",
    isDisable: false,
  },
  {
    companyName: "XYZ Inc",
    includedCerts: "SGBP010,SGBP010/1",
    overseasCharge: "No",
    paymentTerm: "Quarterly",
    invoiceNumber: "INV-002",
    invoiceLink: "https://example.com",
    totalAmount: " $ 2500.00",
    status: "Paid",
    date: "10 Oct 2025 ",
    isDisable: true,
  },
];
const XeroPaymentUpdateList = () => {
  const xeroPaymentlistRef = useRef();
  const molGridRef = useRef();
  const handleSendClick = (data) => {
    alert("clickkkk")
  }
  const actionHandler = {
    SEND: handleSendClick,
  };
  return (
    <>
      {/* {showPageLoader && (
        <div className="processing-modal-overlay">
          <div className="processing-modal">
            <div className="spinner"></div>
            <p>{loaderText}</p>
          </div>
        </div>
      )} */}

      <div className="xero-payment-update-list">
        <div className="payment-update-filter row">
          <div className="status-input col-10">
            <FormCreator
              ref={xeroPaymentlistRef}
              {...xeroPaymentListFormData}
            />
          </div>
          <div className="col-2 xero-right-side-btn mt-0 mb-3 ">
            <div className="d-flex flex-column gap-2">
              <Buttons
                buttonText="Search"
                buttonTypeClassName="success-btn  mb-2"
              // onClick={handleSearch}
              />
              <Buttons
                buttonText="Update"
                buttonTypeClassName="xero-updatebtn btn-right"
              // onClick={handleUpdate}
              // isLoading={paidInvoicesLoading}
              // isDisable={paidInvoicesLoading}
              />
            </div>
          </div>
        </div>
        <div className="payment-update-list">
          <MolGrid
            ref={molGridRef}
            configuration={XeroPaymentListConfig}
            // allowPagination={true}
            dataSource={dataSource}
            // isLoading={isLoading}
            // pagination={paginationRequest}
            // onPageChange={handlePageChange}
            onActionChange={actionHandler}
          />
        </div>
      </div>
    </>
  );
};
export default XeroPaymentUpdateList;
